module.exports = __webpack_public_path__ + "static/media/wmv.59296266.svg";